import type { LoginRequest, RegisterRequest, AuthResponse, TurnstileConfig } from './types';
import { BaseAPI } from '@/lib/api';

class AuthAPI extends BaseAPI {
  // Получение конфигурации Turnstile
  async getTurnstileConfig(): Promise<TurnstileConfig> {
    return this.makeRequest<TurnstileConfig>('/api/auth/turnstile-config');
  }

  // Проверка, является ли IP исключением для Turnstile
  async checkIpExempt(): Promise<{ exempt: boolean; ip: string | null }> {
    return this.makeRequest<{ exempt: boolean; ip: string | null }>('/api/auth/check-ip-exempt');
  }

  // Авторизация пользователя
  async loginUser(credentials: LoginRequest): Promise<AuthResponse> {
    return this.makeRequest<AuthResponse>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });
  }

  // Регистрация пользователя
  async registerUser(credentials: RegisterRequest): Promise<AuthResponse> {
    return this.makeRequest<AuthResponse>('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });
  }

  // Выход из системы
  async logoutUser(): Promise<AuthResponse> {
    return this.makeRequest<AuthResponse>('/api/auth/logout', {
      method: 'POST',
    });
  }

  // Получение информации о текущем пользователе
  async getCurrentUser(): Promise<AuthResponse> {
    const result = await this.makeAuthRequest<AuthResponse>('/api/auth/me');
    
    if (result.success && result.data) {
      return result.data;
    }
    
    // Для 401 или других ошибок возвращаем стандартный ответ
    return { 
      success: false, 
      message: result.error || 'Not authenticated', 
      user: undefined 
    };
  }

  // Обновление токенов
  async refreshTokens(): Promise<AuthResponse> {
    return this.makeRequest<AuthResponse>('/refresh', {
      method: 'POST',
    });
  }
}

// Создаем экземпляр API
const authAPI = new AuthAPI();

// Экспортируем функции для обратной совместимости
export async function getTurnstileConfig(): Promise<TurnstileConfig> {
  return authAPI.getTurnstileConfig();
}

export async function checkIpExempt(): Promise<{ exempt: boolean; ip: string | null }> {
  return authAPI.checkIpExempt();
}

export async function loginUser(credentials: LoginRequest): Promise<AuthResponse> {
  return authAPI.loginUser(credentials);
}

export async function registerUser(credentials: RegisterRequest): Promise<AuthResponse> {
  return authAPI.registerUser(credentials);
}

export async function logoutUser(): Promise<AuthResponse> {
  return authAPI.logoutUser();
}

export async function getCurrentUser(): Promise<AuthResponse> {
  return authAPI.getCurrentUser();
}

export async function refreshTokens(): Promise<AuthResponse> {
  return authAPI.refreshTokens();
}

// Экспортируем также сам класс
export { authAPI };
